<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="streetsList"
      :items="streetsList"
      :fields="streetsFields"
      :filter="filter"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="currentRowStreets"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      currentRowStreets: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      streetsFields: [
        {key: 'street_id', label: 'ID', sortable: true},
        {key: 'country', label: this.$i18n.t('Country'), sortable: true},
        {key: 'region', label: this.$i18n.t('Province/State'), sortable: true},
        {key: 'city', label: this.$i18n.t('City'), sortable: true},
        {key: 'street', label: this.$i18n.t('Street'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    showAdd () {
      this.currentRowStreets = {
        street_id: 0,
        street: '',
        country: '',
        region: '',
        city: ''
      }
      this.$root.$emit('bv::show::modal', 'modalEdiStreets', '#btnShow')
    },
    editItem (item) {
      this.currentRowStreets = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEdiStreets', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Streets"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('ReferenceBooks/DELETE_STREETS', item.street_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'ReferenceBooks/GET_STREETS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    streetsList () {
      return this.$store.getters['ReferenceBooks/STREETS']
    }
  },
  mounted () {
    this.$store.dispatch('ReferenceBooks/GET_STREETS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/streets/main.vue